<template>
    <Fragment v-if="configurations && configurations.length">
        <!-- TABLE DESKTOP -->
        <table
            class="d-lg-table"
            width="100%"
        >
            <thead>
                <tr style="border-bottom: 1px solid #ccc">
                    <th class="text-center">
                        {{ $t("config_manag_table_header_name") }}
                    </th>
                    <th class="text-center">
                        {{ $t("config_manag_table_header_date") }}
                    </th>
                    <th class="text-center">
                        {{ $t("config_manag_table_header_gama") }}
                    </th>
                    <th class="text-center" v-if="false">
                        {{ $t("config_manag_table_header_actions") }}
                    </th>
                    <th class="text-center" v-if="false">
                        {{ $t("config_manag_table_header_downloads") }}
                    </th>
                    <th class="text-center">
                        <!-- SELECTION -->
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(configuration, key, index) in configurations"
                    :key="index"
                    style="border-bottom: 1px solid #ccc"
                >
                    <td class="text-left">
                        <a href="javascript:void(0);" @click="viewConfig(configuration.id)"
                            style="text-decoration: underline">
                            {{ configuration.label }}
                        </a>
                    </td>
                    <td class="text-center" width="20%">
                        {{ configuration.updated_at_formatted }}
                    </td>
                    <td class="text-left" width="30%">
                        {{ configuration.gama ? configuration.gama.name : "" }}
                    </td>

                    <td v-if="false" class="text-center">
                        <i
                            data-toggle="modal"
                            @click="viewConfig(configuration.id)"
                            title="View"
                            class="fas fa-eye mr-3"
                        ></i>
                        <i
                            @click="deleteConfig(configuration.id)"
                            title="Delete"
                            class="fas fa-trash-alt"
                        ></i>
                    </td>

                    <!-- downloads -->
                    <td v-if="false" class="text-center">
                        <i
                            @click="downloadExcel(configuration.id)"
                            title="Excel"
                            class="fas fa-file-excel fa-lg mr-3"
                        ></i>
                        <i
                            @click="downloadPdf(configuration.id)"
                            title="Pdf"
                            class="fas fa-file-pdf fa-lg"
                        ></i>
                    </td>

                    <td>
                        <!-- SELECTION -->
                        <input
                            v-if="enableSelection && app.configs.selectionMode"
                            type="checkbox"
                            :checked="configuration.selected"
                            :key="configuration.id + count"
                            @change="
                                $event.target.checked
                                    ? (configuration.selected = true)
                                    : (configuration.selected = false)
                            "
                        />
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- MODAL VIEW CONFIG -->
        <div
            id="viewConfigModal"
            ref="viewConfigModal"
            class="modal fade viewConfigurationModal"
            tabindex="-1"
            role="dialog"
        >
            <div
                class="
                    modal-dialog
                    modal-dialog-centered
                    modal-dialog-scrollable
                    modal-xl
                "
                style="min-width: 80%"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">{{ $t("configuration") }}</div>
                    <div class="modal-body scrollable">
                        <configuration-component
                            ref="viewConfigurationComponent"
                            :configuration="selectedConfig"
                        ></configuration-component>
                    </div>
                    <div class="modal-footer">
                        <configuration-actions-component
                            ref="viewConfigurationActionsComponent"
                            :selectionActions="true"
                            :closeAction="true"
                            :configuration="selectedConfig"
                        ></configuration-actions-component>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import configurationComponent from "./configuration.vue"
import configurationActionsComponent from "./configurationActions.vue"

export default {
    name: 'configurationsComponent',
    props: {
        configurations: Array,
        enableSelection: false
    },

    components: {
        Fragment,
        configurationComponent, configurationActionsComponent,
    },
    data() {
        return {
            app: app,
            count: 1,
            selectedConfig: {

            }
        }
    },
    methods: {

        viewConfig: async function (configurationId) {
            // Load Config
            this.app.configs.selectionMode = false
            var config = await this.app.API.getConfig(configurationId)
            config.isEditing = false
            this.selectedConfig = config

            // Opens modal
            jQuery(this.$refs["viewConfigModal"]).modal("show")
        }
    }
}
</script>

<style>
</style>